import React, { useState, useLayoutEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import MyGroupService from '@/services/MyGroup.service';
import { useSnackbar } from 'notistack';
import { MyGroup } from '@/types/MyGroup.type';
import { Messages, Category } from '@/common/constants';
import { Box, Grid, IconButton } from '@mui/material';
import PageTitle from '@/components/common/PageTitle';
import ConfirmDialog from '@/components/common/ConfirmDialog';
import Loading from '@/components/common/Loading';
import URL from '@/common/routes/Url';
import useSidebar from '@/common/hooks/useSidebar';

interface DelType {
  id: number;
  name: string;
}

const MyGroupList: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { reload } = useSidebar();
  const [myGroups, setMyGroups] = useState<Array<MyGroup>>([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [delMyGroup, setDelMyGroup] = useState<DelType>({ id: 0, name: '' });

  const retrieveMyGroups = () => {
    MyGroupService.getEditables()
      .then((response) => {
        setMyGroups(response.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        enqueueSnackbar(Messages.select.failure);
      });
  };

  useLayoutEffect(() => {
    retrieveMyGroups();
  }, []);

  const createMyGroup = () => {
    navigate(`${URL.myGroups}/add`);
  };

  const editMyGroup = (id: number) => {
    navigate(`${URL.myGroups}/${id}`);
  };

  const deleteMyGroup = async (id: number) => {
    try {
      await MyGroupService.delete(id);
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message);
      return;
    }
    reload();
    enqueueSnackbar(Messages.delete.success, { variant: 'info' });
    retrieveMyGroups();
  };

  const handleDialog = (id: number, name: string) => {
    setDelMyGroup({
      id: id,
      name: name,
    });
    setOpen(true);
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Box sx= {{ display: { xs: 'block', sm: 'none' } }}>
          <PageTitle>Myグループ一覧</PageTitle>
        </Box>
        <Box sx={{ marginBottom: '8px' }}>
          <Button variant="contained" color="primary" onClick={() => createMyGroup()}>
            追加画面へ
          </Button>
        </Box>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>グループ名</TableCell>
                {/* <TableCell>グループの種類</TableCell> */}
                <TableCell>グループの説明</TableCell>
                <TableCell width="150"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {myGroups.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  {/* <TableCell>
                    {row.category === Category.プライベート && 'プライベート'}
                    {row.category === Category.共有 && '共有'}
                    {row.category === Category.パブリック && 'パブリック'}
                  </TableCell> */}
                  <TableCell>{row.memo}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => editMyGroup(row.id)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDialog(row.id, row.name)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <ConfirmDialog
          open={open}
          onClose={() => setOpen(false)}
          onOk={() => {
            setOpen(false);
            deleteMyGroup(delMyGroup.id);
          }}
        >
          {delMyGroup.name}を本当に削除しますか？
        </ConfirmDialog>
      </Grid>
    </Grid>
  );
};
export default MyGroupList;
